import { IWithChildren } from '@/util/reactTypes';

const mainClass = [
  'min-w-0 flex-1',
  '[&>*]:mb-6 max-lg:[&>*]:mb-5 max-lg:mb-5',
].join(' ');

export function Main({
  children,
}: { } & IWithChildren) {
  return (
    <div className={mainClass}>
      {children}
    </div>
  );
}
